module.exports = "images/doc-activity-add-2.08e7b50aaee18a48eef03dd1cda5a441.png";